import styled from 'styled-components';
import tw from 'twin.macro';

export const PageTitle = styled.h1`
  ${tw`headline-lg-bold text-gray-900`}
`;
